import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { DumbMemberDiscount } from '../DTOs/dumb-member-discount';
import { GetMemberDiscountsRequest } from '../DTOs/get-company-discounts-search-request';
import { GetPublicMembersRequest } from '../DTOs/get-public-members-request';
import { PublicMemberSearchResults } from '../DTOs/public-member-search-results';
import { MemberInformationService } from '../member-information.service';

@Component({
  selector: 'app-member-discounts',
  templateUrl: './member-discounts.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class MemberDiscountsComponent {
  constructor(private memberInformationService: MemberInformationService
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService
    , private modalService: NgbModal) {
  }
  
  fromSearch = 0;
  statusSearch = 0;
  searchText = "";

  discounts: DumbMemberDiscount[] = [];


  ngOnInit() {
    this.searchDiscounts();
  }
  
  searchDiscountsObservable(): Observable<DumbMemberDiscount[]> {
    var req = new GetMemberDiscountsRequest(this.fromSearch, this.statusSearch, this.searchText);
    return this.memberInformationService
      .searchMemberDiscounts(req);
  }

  searchDiscounts(clearResults = false) {
    this.blockUI.start();

    this.searchDiscountsObservable()
      .subscribe(
        {
          next: (data) => {
            this.discounts = data;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }
}
